import { Box } from "@mui/material";

const SectionWrapper = ({
  children,
  maxWidth = "1000px",
  background,
  id,
  sx = {},
  innerSx = {},
  ...props
}) => {
  return (
    <Box
      id={id}
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        py: { xs: 4, md: 5 },
        px: { xs: 2, md: 3 },
        ...(background && { background }),
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth,
          ...innerSx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SectionWrapper;
